import React from "react";
import { Divider, useTheme } from "@mui/material";
import { dashboard2WeekDayRowDividerSx } from "../dashboard2-status.styles";

export const Dashboard2WeekDayRowDivider: React.FC = () => {
  const theme = useTheme();

  return (
    <Divider
      sx={dashboard2WeekDayRowDividerSx(theme)}
      data-testid="dashboard2-week-day-row-divider"
    />
  );
};
